import {useQuery} from '@tanstack/react-query';

import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAdherenceDigitalPayment} from '../../services/getAdherenceDigitalPayment';

const ADHERENCE_COLUMN_NAME = 'DT_BOLETOS_ADESAO';

export const useGetAdherenceDigitalPaymentQuery = (enabled: boolean) =>
	useQuery({
		queryKey: [QUERY_KEYS.ADHERENCE_DIGITAL_PAYMENT],
		queryFn: async ({signal}) =>
			getAdherenceDigitalPayment({
				columnName: ADHERENCE_COLUMN_NAME,
				signal,
			}),
		enabled,
		retry: 1,
	});
